import { LineTypeCode } from "@/types";
import { computed, Ref } from "vue";

export const useLineTypeChipClass = (lineTypeCode: Ref<LineTypeCode>) => {
  const lineTypeClass = computed(() => {
    switch (lineTypeCode.value) {
      case LineTypeCode.Forward:
        return "forward";
      case LineTypeCode.Backward:
        return "backward";
      case LineTypeCode.Shuttle:
        return "shuttle";
      case LineTypeCode.Inside:
        return "inside";
      default:
        return ""; // 기본값 또는 에러 처리
    }
  });

  return {
    lineTypeClass,
  };
};
